import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=ccb0b270&scoped=true&"
import script from "./ResultList.vue?vue&type=script&lang=js&"
export * from "./ResultList.vue?vue&type=script&lang=js&"
import style0 from "./ResultList.vue?vue&type=style&index=0&id=ccb0b270&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb0b270",
  null
  
)

export default component.exports